const icons = {
  date: (backgroundColor: string) => (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17.99" {...props}>
      <path
        d="m0,6.44h18v9.6c0,.91-.57,1.65-1.43,1.88-.18.05-.37.07-.56.07H1.99c-1.15,0-1.99-.83-1.99-1.99V6.43h0Z"
        fill={backgroundColor || '#2EC5CE'}
        strokeWidth={0}
      />
      <path
        d="m16.39,1.32c-.52-.06-1.06-.03-1.58-.03v1.85c0,.42-.27.7-.65.7s-.64-.29-.64-.7v-1.85h1.26,0s.02,0,.03,0h0s-.02,0-.02,0v-.64C14.78.28,14.5,0,14.15,0c-.36,0-.65.27-.65.64v.64H4.51v1.86c0,.42-.27.7-.65.7s-.64-.29-.64-.7v-1.85h1.28v-.64C4.49.28,4.22,0,3.86,0s-.64.27-.64.64v.64h-1.24c-1.13,0-1.98.84-1.98,1.97v1.71c0,.06,0,.12,0,.17h17.98v-1.84c0-.09,0-.17,0-.26-.09-.88-.74-1.61-1.61-1.71Z"
        fill={backgroundColor || '#2EC5CE'}
        strokeWidth={0}
      />
    </svg>
  ),
  time: (backgroundColor: string) => (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
      <path
        d="M2.80924e-05 8.99541C0.0128336 4.01801 4.05375 -0.0107355 9.02282 2.14912e-05C13.9647 0.0107785 18.0174 4.07691 18 9.00719C17.9821 14.0225 13.933 18.0231 8.89835 18C4.01175 17.9775 -0.0122652 13.9047 2.80924e-05 8.99541ZM9.81472 6.30105H9.81369C9.81369 5.5665 9.81882 4.83144 9.81165 4.09689C9.80704 3.62307 9.45975 3.2809 9.00336 3.27936C8.54543 3.27782 8.18944 3.61897 8.1879 4.08921C8.18227 5.72478 8.18585 7.35984 8.18534 8.99541C8.18534 9.21721 8.25807 9.41084 8.41328 9.56707C9.23847 10.3954 10.0631 11.2236 10.894 12.0463C11.1158 12.266 11.3954 12.3224 11.693 12.2317C12.2928 12.0483 12.466 11.3194 12.0132 10.8594C11.3319 10.1674 10.643 9.48306 9.95302 8.79974C9.85518 8.70292 9.8096 8.60765 9.81062 8.46627C9.81779 7.74453 9.81421 7.02228 9.81421 6.30053L9.81472 6.30105Z"
        fill={backgroundColor || '#2EC5CE'}
        strokeWidth={0}
      />
    </svg>
  ),
  link: (backgroundColor: string) => (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
      <path
        d="M9.52445 18.0002H8.46951C8.16823 17.9623 7.86518 17.935 7.5661 17.8852C5.68571 17.5708 4.04714 16.7624 2.69841 15.4155C0.67531 13.3944 -0.214889 10.9382 0.0436693 8.09463C0.217216 6.18582 0.964702 4.4985 2.24164 3.06481C3.93747 1.16085 6.07157 0.135331 8.61839 0.0111596C10.3944 -0.0751439 12.0642 0.338761 13.5843 1.26564C15.921 2.69053 17.3552 4.75433 17.86 7.45087C17.923 7.78816 17.9543 8.13161 18.0001 8.47242V9.527C17.9855 9.65337 17.971 9.77975 17.9569 9.90656C17.7415 11.8431 17.0015 13.5516 15.6955 15.0002C14.3089 16.5383 12.591 17.4982 10.5472 17.8601C10.2085 17.92 9.86537 17.9539 9.52401 18.0002H9.52445ZM10.201 8.97836C10.1248 9.05761 10.0821 9.10429 10.0372 9.14964C9.04697 10.1395 8.05679 11.1293 7.06704 12.1196C7.0133 12.1733 6.96 12.2284 6.91287 12.2878C6.61731 12.6612 6.73052 13.1901 7.15205 13.412C7.46655 13.5775 7.79602 13.5115 8.09026 13.2174C9.28439 12.0254 10.4776 10.8326 11.6709 9.63972C12.11 9.20072 12.1114 8.80091 11.6748 8.36498C10.4939 7.18448 9.31302 6.00441 8.13167 4.82478C8.07793 4.77106 8.02287 4.71778 7.96385 4.67023C7.54055 4.33294 6.92829 4.52712 6.77941 5.04626C6.68603 5.37166 6.80936 5.62573 7.03665 5.8525C8.03256 6.84499 9.02583 7.84012 10.0209 8.83305C10.0702 8.88237 10.1301 8.92155 10.201 8.9788V8.97836Z"
        fill={backgroundColor || '#2EC5CE'}
        strokeWidth={0}
      />
    </svg>
  ),
  pin: (backgroundColor: string) => (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78 94" {...props}>
      <path
        d="M39.1764 0.5C28.9229 0.51128 19.0925 4.58919 11.8419 11.8391C4.5912 19.0891 0.512308 28.919 0.5 39.1725C0.5 49.1313 8.21125 64.7165 23.4206 85.4943C25.2313 87.9748 27.602 89.9927 30.3398 91.3839C33.0777 92.7751 36.1053 93.5002 39.1764 93.5002C42.2474 93.5002 45.2751 92.7751 48.0129 91.3839C50.7508 89.9927 53.1215 87.9748 54.9321 85.4943C70.1415 64.7165 77.8528 49.1313 77.8528 39.1725C77.8405 28.919 73.7616 19.0891 66.5109 11.8391C59.2602 4.58919 49.4299 0.51128 39.1764 0.5ZM39.1764 54.5873C36.1108 54.5873 33.114 53.6782 30.565 51.975C28.0161 50.2719 26.0294 47.8511 24.8562 45.0188C23.6831 42.1866 23.3761 39.0701 23.9742 36.0634C24.5723 33.0566 26.0485 30.2948 28.2162 28.1271C30.3839 25.9594 33.1458 24.4832 36.1525 23.8851C39.1592 23.287 42.2757 23.594 45.108 24.7671C47.9402 25.9403 50.361 27.927 52.0642 30.4759C53.7673 33.0249 54.6764 36.0216 54.6764 39.0873C54.6764 43.1981 53.0433 47.1406 50.1365 50.0474C47.2297 52.9542 43.2872 54.5873 39.1764 54.5873Z"
        fill={backgroundColor || '#2EC5CE'}
        strokeWidth={0}
      />
    </svg>
  )
};

type SvgIconsProps = {
  iconName: keyof typeof icons;
  sizeWidth?: string;
  sizeHeight?: string;
  backgroundColor?: string;
};

const SvgIcons = ({
  iconName,
  sizeWidth = '25px',
  sizeHeight = '24px',
  backgroundColor
}: SvgIconsProps) => {
  const Svg = icons[iconName](backgroundColor || '#2EC5CE');

  return <Svg width={sizeWidth} height={sizeHeight} />;
};

export default SvgIcons;
